import ConfirmModal from '@components/modal/ConfirmModal';
import { useHistory } from 'react-router-dom';
import { SuperAdminUser } from 'src/types/shared/SuperAdminUser';
import useDeleteSuperAdmin from './hooks/useDeleteSuperAdmin';

const DeleteSuperAdminModal: React.FC<DeleteAdminProps> = ({ user }) => {
    const history = useHistory();
    const { deleteUser, isPosting, error } = useDeleteSuperAdmin(user.id);

    return (
        <ConfirmModal
            title="Delete super admin"
            description={`Are you sure you want to delete '${user.firstName} ${user.lastName}'?`}
            closeModal={() => history.replace(`/superadmins/${user.id}`)}
            handleSubmit={deleteUser}
            isPosting={isPosting}
            error={error}
        />
    );
};

interface DeleteAdminProps {
    user: SuperAdminUser;
}

export default DeleteSuperAdminModal;
